module.exports = __webpack_public_path__ + "media/images/porque/art-cashback-4256ec8f746082388ecae2f6b0ccc463.svg";